module.exports = __webpack_public_path__ + "img/refund.130aaf77.svg";